export const selectCenterId = state => state.auth.selectedCenter.id
